import { urlExam } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyCreateExam, IBodyUpdateExam, IExam, IQueryGetExams } from '~/utils/interface/exam';

export const examApi = {
  getListExams(params: IQueryGetExams) {
    const url = `${urlExam.getList}`;
    return axiosClient.get<IBaseResponse<IListDataResponse<IExam[]>>>(url, { params });
  },

  createExam(body: IBodyCreateExam) {
    const url = `${urlExam.create}`;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateExam(examId: string, body: IBodyUpdateExam) {
    const url = `${urlExam.update(examId)}`;
    return axiosClient.put<IBaseResponse>(url, body);
  },

  getExamById(examId: string) {
    const url = `${urlExam.getById(examId)}`;
    return axiosClient.get<IBaseResponse<IExam>>(url);
  },

  deleteExamById(examId: string) {
    const url = `${urlExam.deleteById(examId)}`;
    return axiosClient.delete<IBaseResponse>(url);
  },
};
